<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <b-row>
                <b-col md="6">
                    <div class="font-weight-bold">Kloter Pengiriman</div>
                    {{ $helper.parseDate(item.delivery_date) }} - Cabang {{ item.branch }}
                </b-col>
                <b-col md="6">
                    <div class="font-weight-bold">Status Barang</div>
                    <b-badge :variant="parseStatusVariant(item.status)">
                        {{ parseStatusName(item.status) }}
                    </b-badge>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col md="6">
                    <div class="font-weight-bold">Jenis Barang</div>
                    {{ item.kind }}
                    <div class="font-weight-bold mt-3">Merk Barang</div>
                    {{ item.brand }}
                    <div class="font-weight-bold mt-3">Tipe Barang</div>
                    {{ item.type }}
                    <div class="font-weight-bold mt-3">Spek dari PGI</div>
                    {{ specName(item.pgi_spec_id) }}
                    <div class="font-weight-bold mt-3">Tahun / Generasi Barang</div>
                    {{ item.year || "-" }}
                </b-col>
                <b-col md="6">
                    <div class="font-weight-bold">No. Faktur PGI</div>
                    {{ item.no_faktur }}
                    <div class="font-weight-bold mt-3">IMEI / SN</div>
                    {{ item.imei_sn }}
                    <div class="font-weight-bold mt-3">Password</div>
                    {{ item.password || "-" }}
                    <div class="font-weight-bold mt-3">Grade / Kelengkapan dari PGI</div>
                    {{ item.grade_pgi || "-" }} / {{ item.is_batangan_pgi == 1 ? "Batangan" : "Lengkap" }}
                </b-col>
            </b-row>
            <hr />
            <div><!-- PENDING -->
                <h5>Input Data Barang</h5>
                <b-row>
                    <b-col md="6" >
                        <b-form-group label="Accessories yang Tidak Ada">
                            <multiselect v-model="input.missingAcc" :multiple="true" label="name" track-by="id"
                                :internal-search="true" deselect-label="" select-label="" :options="optAccessories"
                                :close-on-select="false" />
                        </b-form-group>
                    </b-col>
                    <b-col md="6" >
                        <b-form-group label="Accessories yang Tidak Ori">
                            <multiselect v-model="input.nonOriAcc" :multiple="true" label="name" track-by="id"
                                :internal-search="true" deselect-label="" select-label="" :options="optAccessories"
                                :close-on-select="false" />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12" class="text-right">
                        <b-button variant="success" :disabled="isSubmitting" @click="promptSubmit">
                            {{ isSubmitting ? "Menyimpan..." : "Approve Aksesoris" }}
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>

import lodash from 'lodash'

export default {
    name: 'barang-masuk-detail-barang',
    props: {
        inventoryId: { type: Number, required: true }
    },
    data() {
        return {

            initStatus: 0,
            isSubmitting: false,
            isFetching: false,
            firstLoad: false,

            item: {},
            input: {
                missingAcc: [],
                nonOriAcc: [],
            },
        }
    },
    methods: {

        init() {

            this.initStatus = 0
            this.optSpec = [];
            this.optWarehouse = [];
            this.optAccessories = [];
            this.optColor = [{ value: -1, text: "Pilih Warna" }];

            this.$axios.get("delivery/inventory/aksesoris/" + this.inventoryId).then(res => {
                this.item = res.data.data

                this.item.available_accessories.forEach(it => {
                    this.optAccessories.push({ id: it.id, name: it.name })
                })

                this.initStatus = 1
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.initStatus = -1
                })

        },

        promptSubmit() {

            let confirmable = true

            if (confirmable) {
                let confirmed = confirm("Lakukan approval dengan data input ini?")
                if (confirmed) {

                    let jsonData = {
                        id: this.inventoryId,
                        missingAcc: this.input.missingAcc,
                        nonOriAcc: this.input.nonOriAcc,
                    }

                    this.isSubmitting = true
                    this.$axios.post("delivery/insert-accesories", jsonData).then(res => {
                        // Emit to parent
                        this.$emit("approved")
                    })
                        .catch(error => this.$helper.parseError(this, error))
                        .finally(() => this.isSubmitting = false)

                }
            }




        },

        parseStatusVariant(status) {

            switch (status) {
                case 1: return "warning"
                case 2: return "success"
                case 5: return "danger"
                default: return "light"
            }

        },

        parseStatusName(status) {

            switch (status) {
                case 1: return "PENDING"
                case 2: return "APPROVED"
                case 5: return "HILANG"
                default: return "LAINNYA"
            }

        },

        specName(id) {
            switch (id) {
                case 1: return "ORI"
                case 2: return "RESMI"
                case 3: return "RR"
                case 5: return "LN"
                default: return "-"
            }
        },
    },
    created() {
        this.init()
    }
}
</script>

<style scoped>
.multiselect__option--highlight .option__small {
    color: #d8dbde !important;
}

.multiselect__option--selected .option__small {
    color: #ccccee !important;
}

.multiselect__option--highlight.multiselect__option--selected .option__small {
    color: #ccccee !important;
}

/deep/ .multiselect__tag {
    color: #fff !important;
    background: #10469A !important;
}

/deep/ .adjust-column-min {
    min-width: 200px;
}

.media-container {
    height: 0;
    padding-top: 56.25%;
    position: relative;
}

.media-preview {
    max-height: 100%;
    max-width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid #dee2e6;
    border-radius: .25rem;
    object-fit: cover;
    background-color: #dee2e6;
    left: 50%;
    transform: translateX(-50%);
}

:not(:root):-webkit-full-screen {
    object-fit: contain !important;
}

.media-scroll {
    margin-top: 10px;
    height: 70px;
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    background-color: #dee2e6;
    white-space: nowrap;
}

.media-scroll-content {
    display: inline-block !important;
    height: 100%;
    width: 20%;
}

.media-scroll-preview.active {
    border: 5px solid #65c2e4;
}

.media-scroll-preview:hover {
    opacity: 0.5;
}

.media-scroll-preview {
    height: 100%;
    width: 100%;
    border: 5px solid #dee2e6;
    border-radius: .25rem;
    object-fit: cover;
    background-color: #dee2e6;
    cursor: pointer;
}

.border-responsive {
    margin-top: 10px;
    border-top: 1px solid #c8ced3;
}

.media-disclaimer {
    text-align: justify;
    text-justify: inter-word;
}

@media only screen and (min-width: 576px) {
    .media-scroll {
        height: 100px;
    }
}

@media only screen and (min-width: 992px) {
    .border-responsive {
        margin-top: 0px;
        border-top: none;
        border-left: 1px solid #c8ced3;
    }
}

@media only screen and (min-width: 1200px) {
    .media-scroll {
        height: 150px;
    }
}
</style>
